// Poppins carries the headings in the 2026 identity (ASKHVAC-REDESIGN.md);
// Fraunces belonged to the editorial build this replaced.
import '@fontsource/poppins/600.css'
import '@fontsource/poppins/700.css'
import '@fontsource/poppins/800.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@/styles/themes/askhvac.scss'
import '@/styles/base.scss'
import { createApp } from 'vue'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { vReveal } from '@/shared/directives/reveal'
import App from './App.vue'
import { router } from './router'

createApp(App)
    .use(router)
    .use(VueQueryPlugin)
    .directive('reveal', vReveal)
    .mount('#app')
